import { createAction, createReducer, createSelector } from "@reduxjs/toolkit";
import type { RootState } from "../store";
import type { RouterOutputs } from "@project/api";

type APIKey = RouterOutputs["getDefaultApiKey"];

export interface APIKeyState {
  default: APIKey | null;
}

const initialState: APIKeyState = {
  default: null,
};

export const setDefaultApiKey = createAction<APIKey>("apiKey/setDefaultApiKey");

export const apiKeyReducer = createReducer(initialState, (builder) => {
  builder.addCase(setDefaultApiKey, (state, action) => {
    state.default = action.payload;
  });
});

export const getAPiKeyStateSelector = createSelector(
  (state: RootState) => state,
  state => state.apiKey,
);

export const getDefaultApiKeySelector = createSelector(
  getAPiKeyStateSelector,
  apiKey => apiKey.default?.key,
);
